<template>
  <div class="orders-page">
    <h1>我的订单</h1>
    <p class="page-description">查看购买金额、支付状态及订单详情。</p>
    <div v-if="loading" class="order-feedback">正在加载订单…</div>
    <div v-else-if="loadFailed" class="order-feedback">订单加载失败 <el-button type="text" @click="fetchData(currentPage, pageSize)">重试</el-button></div>
    <div v-else class="mobile-orders">
      <article v-for="order in pagedData" :key="order.orderNo" class="order-card">
        <div class="order-heading"><strong>{{ order.orderAmountStr }}</strong><span>{{ order.orderStatusStr }}</span></div>
        <p>支付时间：{{ order.paySuccessTimeStr || '—' }}</p>
        <p>订单号：{{ order.orderNo }}</p>
        <details><summary>订单详情</summary><p>微信订单号：{{ order.weixinOrderNo || '—' }}</p><p>支付类型：{{ order.tradeTypeStr || '—' }}</p><p>支付渠道：{{ order.payChannel || '—' }}</p><p>用户：{{ order.userName }}</p></details>
      </article>
      <p v-if="!pagedData.length" class="order-feedback">暂无订单</p>
    </div>
    <el-table class="desktop-orders" :data="pagedData" style="width: 100%">
      <!-- <el-table-column prop="id" label="ID" width="180"></el-table-column> -->
      <el-table-column
        prop="orderNo"
        label="订单号"
        width="230"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="weixinOrderNo"
        label="微信订单号"
        width="210"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="orderAmountStr"
        label="订单金额"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="orderStatusStr"
        label="订单状态"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="tradeTypeStr"
        label="支付类型"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="payChannel"
        label="支付渠道"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="userName"
        label="用户名"
        width="180"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="paySuccessTimeStr"
        label="支付时间"
        width="200"
        align="center"
      ></el-table-column>
    </el-table>
    <el-pagination
      :pager-count="5"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import { getOrderPage } from '@/api/pay'

export default {
  data () {
    return {
      pagedData: [],
      allData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      loadFailed: false
    }
  },
  methods: {
    async fetchData (page = 1, size = 10) {
      this.loading = true
      this.loadFailed = false
      try {
        const result = await getOrderPage(page, size)
        const { records, total, current } = result.data
        this.pagedData = records || []
        this.total = +total
        this.pageSize = +result.data.size
        this.currentPage = +current
      } catch (error) {
        this.loadFailed = true
      } finally {
        this.loading = false
      }
    },
    handleSizeChange (newSize) {
      this.pageSize = newSize
      this.fetchData(1, this.pageSize)
    },
    handleCurrentChange (newPage) {
      this.currentPage = newPage
      this.fetchData(this.currentPage, this.pageSize)
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style lang="less" scoped>
/* 你可以在这里添加样式 */
h1 {
  font-size: 24px;
  margin: 10px 0 10px 10px;
}

.el-table {
  margin: 10px 0 10px 20px;
}

.el-pagination {
  text-align: center;
}

/* 移动端适配 - 不影响PC端 */
@media screen and (max-width: 768px) {
  .el-table {
    margin: 10px 0;
    font-size: 12px;
    overflow-x: auto;
    display: block;
    white-space: nowrap;
  }

  .el-pagination {
    font-size: 12px;
    padding: 10px 0;
  }
}
</style>
<style lang="less" scoped>
.orders-page { padding: 20px; min-width: 0; }
.orders-page h1 { font-size: 22px; margin: 0 0 16px; }
.orders-page .el-table { margin: 0 0 16px; }
.mobile-orders { display: none; }
.order-feedback { padding: 20px; color: #65758a; text-align: center; }
@media screen and (max-width: 768px) {
  .orders-page { padding: 14px 12px; }
  .orders-page h1 { font-size: 20px; }
  .orders-page .desktop-orders { display: none; }
  .mobile-orders { display: grid; gap: 10px; }
  .order-card { padding: 14px; border: 1px solid #e3e9f0; border-radius: 8px; background: #fff; }
  .order-heading { display: flex; justify-content: space-between; align-items: center; gap: 8px; margin-bottom: 8px; }
  .order-heading strong { font-size: 20px; color: #24364b; }
  .order-heading span { color: #2676d9; font-size: 12px; }
  .order-card p { font-size: 12px; color: #65758a; line-height: 1.8; overflow-wrap: anywhere; }
  .order-card summary { padding: 8px 0; color: #2676d9; font-size: 13px; cursor: pointer; }
}
</style>
